const menu = [
  {
    type: 'Breakfast',
    categories: [
      {
        name: 'Vegetarian',
        dishes: [
          {
            name: 'Scrambled eggs',
            description: 'Best scrabled eggs you can imagine',
            price: '3.54',
          },
          {
            name: 'Bagel with spinach, egg and tofu',
            description: 'Best scrabled eggs you can imagine',
            price: '3.54',
          },
          {
            name: 'Toast with roasted beetroot and eggs',
            description: 'Best scrabled eggs you can imagine',
            price: '3.54',
          },
        ],
      },
      {
        name: 'Vegan',
        dishes: [
          {
            name: 'Scrambled tofu',
            description: 'Best scrabled eggs you can imagine',
            price: '3.54',
          },
          {
            name: 'Bagel with spinach and tofu',
            description: 'Best scrabled eggs you can imagine',
            price: '3.54',
          },
          {
            name: 'Toast with roasted beetroot',
            description: 'Best scrabled eggs you can imagine',
            price: '3.54',
          },
        ],
      },
    ],
  },
  {
    type: 'Lunch',
    categories: [
      {
        name: 'Appetizers',
        dishes: [
          {
            name: 'Chicken wings',
            description:
              'It’s all about flavour and fun, fun, fun. Toss fried chicken with a finger-licking sauce spiked with chilli and fresh ginger.',
            price: '9.95',
          },
          {
            name: 'Dumplings',
            description:
              'Small dumplings filled with spiced lamb. Tossed in a tomato sauce and served with sumac-flavoured Greek yoghurt.',
            price: '5.70',
          },
          {
            name: 'French onion soup',
            description:
              'French onion soup is deeply savoury and hearty - and cheesy croutons make it extra special!',
            price: '5.80',
          },
          {
            name: 'Mini chilli pretzels',
            description:
              'These freshly-baked savouries beat anything out of a packet.',
            price: '2.10',
          },
        ],
      },
      {
        name: 'Entrees',
        dishes: [
          {
            name: 'Atlantic salmon',
            description:
              'Have dinner on the table super fast with clever shortcuts and this easy salmon and Greek rice salad.',
            price: '7.30',
          },
          {
            name: 'Fish tacos',
            description:
              'Fish is a healthy, low-fat taco filling, and it tastes absolutely delicious.',
            price: '5.54',
          },
          {
            name: 'Sesame Tuna',
            description:
              'Sesame seeds form a tasty crust and are rich in calcium, copper and magnesium.',
            price: '4.64',
          },
          {
            name: 'Parmesan chicken',
            description:
              'This crunchy crumbed chicken tastes fabulous paired with the fresh flavours of zucchini, mint and olives.',
            price: '8.35',
          },
        ],
      },
      {
        name: 'Main courses',
        dishes: [
          {
            name: 'Seared scallops',
            description:
              'Escape the hustle and bustle with this exotic breakfast that will satisfy your taste buds.',
            price: '3.84',
          },
          {
            name: 'Poached salmon',
            description:
              'Decidedly gourmet poached salmon dish with a zingy watercress mayonnaise.',
            price: '9.25',
          },
          {
            name: 'Green curry',
            description:
              'This balance of sweet, sour and salty flavours is a hallmark of Thai cooking.',
            price: '7.54',
          },
        ],
      },
      {
        name: 'Salads',
        dishes: [
          {
            name: 'Lobster salad',
            description:
              'A simple lobster salad with butter and just a hint of mayonnaise so that you can still taste the sweet lobster meat. ',
            price: '6.54',
          },
          {
            name: 'Chicken & orange salad',
            description:
              'With juicy oranges and a yoghurt dressing, this chicken salad is a treat on any spring table. ',
            price: '8.54',
          },
          {
            name: 'Winter salad',
            description: 'This is a simple winter salad,  fresh and crisp.',
            price: '4.54',
          },
          {
            name: 'Thai-style salad',
            description: 'This is a simple winter salad,  fresh and crisp. ',
            price: '5.05',
          },
        ],
      },
    ],
  },
  {
    type: 'Drinks',
    categories: [
      {
        name: 'Non-alcoholic',
        dishes: [
          {
            name: 'Green tea',
            description: 'Best Indian green tea',
            price: '3.54',
          },
          {
            name: 'White tea',
            description: 'Best Indian green tea',
            price: '3.54',
          },
          {
            name: 'Black tea',
            description: 'Best Indian green tea',
            price: '3.54',
          },
        ],
      },
      {
        name: 'Alcoholic',
        dishes: [
          {
            name: 'Aperol spritz',
            description: 'Best Indian green tea',
            price: '3.54',
          },
          {
            name: 'Cuba libre',
            description: 'Best Indian green tea',
            price: '3.54',
          },
          {
            name: 'Lager beer',
            description: 'Best Indian green tea',
            price: '3.54',
          },
        ],
      },
    ],
  },
  {
    type: 'Desserts',
    categories: [
      {
        name: 'Pies and cakes',
        dishes: [
          {
            name: 'Lava cake',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
          {
            name: 'Chocolate pie',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
          {
            name: 'Strawberry pie',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
          {
            name: 'Peanut butter cake',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
          {
            name: 'Rhubarb pie',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
        ],
      },
      {
        name: 'Cold desserts',
        dishes: [
          {
            name: 'Strawberry ice cream',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
          {
            name: 'Fruit salad',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
          {
            name: 'Frozen banana ice cream',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
          {
            name: 'Frozen peanut butter banana bites',
            description: 'Best chocolate lava cake',
            price: '3.54',
          },
        ],
      },
    ],
  },
];

export default menu;
